const isLayoutMobile = function () {
  return window.innerWidth < 768;
};

export default isLayoutMobile;
